import _ from "lodash";

export const parseDocumentations = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) {
    return data.map((datum) => parseDocumentation(datum));
  }
  // If it's an object, convert to array
  return Object.values(data).map((datum) => parseDocumentation(datum));
};

export const parseDocumentation = (api) => {
  if (!api) return;
  const product = api?.product;
  return {
    title: api?.title,
    url: api?.url,
    docUrl: api?.docUrl,
    uuid: api?.uuid,
    alias: api?.alias,
    apiName: api?.title || api?.name,
    deprecated: api?.deprecated,
    version: api?.version,
    product:
      typeof product === "object"
        ? {
            alias: product?.alias,
            title: product?.title,
            uuid: product?.uuid,
          }
        : null,
    tour: api?.tour || null,
    botEnabled: api?.bot_enabled,
    botUrl: api?.bot_url,
  };
};

export const parseTour = (tour) => {
  if (!tour)
    return {
      onTour: false,
      tourItem: null,
      tourIndex: 0,
    };
  const item = tour?.tourItem;
  return {
    onTour: tour?.onTour,
    tourIndex: tour?.tourIndex,
    tourItem: item || null,
  };
};

export const getApiUuidFromHistory = (props, history) => {
  const alias = history.location.pathname;
  const apiDocumentations = parseDocumentations(props.apiDocumentations);
  return _.find(apiDocumentations, { alias });
};
